$(function () {

    if (window.innerWidth >= 1024) {
        var allTableHideDesktop = $('.table-hide-desktop input');
        allTableHideDesktop.prop("disabled", true);
    } else {
        var allTableHideMobile = $('.table-hide-mobile input');
        allTableHideMobile.prop("disabled", true);
    }
});